import { Tooltip, TooltipProps } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type TipProps = Omit<TooltipProps, 'styles'>;

export default function Tip({ children, ...props }: TipProps) {
  return (
    <Tooltip
      radius="xl"
      styles={{
        tooltip: {
          paddingInline: 12,
          paddingBlock: 2,
          fontSize: 'var(--mantine-font-size-textXs)',
          fontWeight: FONT_WEIGHTS.medium,
        },
      }}
      {...props}
    >
      {children}
    </Tooltip>
  );
}
